import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from "react-google-maps"
import mapStyle from './../../assets/mapstyle.json';
import InventoryItem from './InventoryItem';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';
import { updateUserLocation } from '../../actions/appActions';
import { setVolunteerRequest } from '../../actions/volunteerActions';
import VolunteerModal from './VolunteerModal';

const Map  = withScriptjs(withGoogleMap((props)=>{

    // return null;
    const {lat, lng} = props.location || { lat: 51.491758, lng: 0.1596895000000131 };
    console.log('ladd', lat, lng)
    return (
        <GoogleMap
        // defaultOptions={{ styles: mapStyle }}
            customMapStyle={mapStyle}
            defaultZoom={props.zoom || 10}
            defaultCenter={{ lat: lat, lng: lng }}
        >
            {props.markers}
        </GoogleMap>
    )
}));


class VolunteerHitMapView extends React.Component {   

    constructor(props){
        super(props);
        this.locationCheck = this.locationCheck.bind(this);

    }
    componentWillMount(){ }
    
    componentDidMount(){ 

      
    }
    
    
    locationCheck(to){

        navigator.geolocation.getCurrentPosition(
                (position)=>{
                    this.props.updateUserLocation({lat : position.coords.latitude, lng : position.coords.longitude});

                },
                ()=>{
                    console.log('user decided not to share their location');
                }
            );

    }

    
    render(){

        const renderSelected  = ()=>{
            if(!this.props.selectedRef) return null;
            return (
                <VolunteerModal></VolunteerModal>
            )
            
        }
        return (
            <div className="VolunteerHitMapView">
                <style jsx>{`
                    .VolunteerHitMapView {
                        max-width:800px;
                        margin:auto;
                    }
                
                `}</style>
                {renderSelected()}
                <Map

                    isMarkerShown
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBVFAJJM-VC-mzou7pvcjvcbOAxNBdlUHo&v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ width:`100%`, paddingTop:'100%', position : 'relative' }} />}
                    mapElement={<div style={{ position: 'absolute', top:0,left:0,right:0,bottom:0 }} />}
                    location={this.props.location}
                    zoom={this.props.zoom}
                    markers={this.props.children}
                    ></Map>
            </div>
        )
    }
}

VolunteerHitMapView.propTypes = {
}


const mapStateProps = (state) => {
    return {
        selectedRef : state.volunteer.selectedRef,
        location : state.app.userLocation
    };
}

export default  connect(mapStateProps, {setVolunteerRequest, updateUserLocation})(VolunteerHitMapView);



// WEBPACK FOOTER //
// ./src/components/common/VolunteerHitMapView.js